import React from 'react'

import { Formik } from 'formik'

import { Table, Col, Row, Button, Divider, Form } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

import { IdGen } from 'utils'

import * as FormGroups from './formGroups'

const VentasSection = ({ self, id }) => {
  const [sectionData, setSectionData] = React.useState(null)

  const formInitialValues = React.useMemo(() => {
    return {
      condicionPago: '',
      medioPago: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const filtrosConsultasIdTurno = { self: self ? self : undefined, idTurno: id ? id : undefined, ...data }

      FacturacionService.obtenerResumenMovimientoxIdTurnoAsInfoVista(filtrosConsultasIdTurno)
        .then(({ data }) => {
          setSectionData(data)
        })
        .catch(() => {
          setSectionData(null)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
    [self, id]
  )

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Row>
            <Col md={4}>
              <FormGroups.CondicionPagoFormGroup
                iError={errors.condicionPago}
                iTouched={touched.condicionPago}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={4}>
              <FormGroups.MedioPagoFormGroup
                iError={errors.medioPago}
                iTouched={touched.medioPago}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={2}>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Consultar
              </Button>
            </Col>
          </Row>
        )}
      </Formik>
      {sectionData && (
        <>
          <Divider />
          <Row>
            {sectionData.sumaxMedio.map(x => (
              <Col key={x.nombre} md={12}>
                <Form.Group>
                  <Form.Label
                    text={`TOTAL ${x.nombre}`}
                    htmlFor={`input-movimientos-${x.nombre}`}
                    md={5}
                    alignRightAt='md'
                  />
                  <Col md={7}>
                    <Form.InputText
                      id={`input-movimientos-${x.nombre}`}
                      name={`input-movimientos-${x.nombre}`}
                      placeholder={x.monto || '--'}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            ))}
            {sectionData.totalxMedio && (
              <Col md={12}>
                <Form.Group>
                  <Form.Label text='TOTAL VENTAS' htmlFor='input-movimientos-TOTAL-VENTAS' md={5} alignRightAt='md' />
                  <Col md={7}>
                    <Form.InputText
                      id='input-movimientos-TOTAL-VENTAS'
                      name='input-movimientos-TOTAL-VENTAS'
                      placeholder={sectionData.totalxMedio || '--'}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            )}
          </Row>
          <Divider />
          <Table
            headRows={[
              { label: 'LADO' },
              { label: 'SERIE' },
              { label: 'NUMERO' },
              { label: 'COMBUSTIBLE' },
              { label: 'CANTIDAD' },
              { label: 'MONTO' },
              { label: 'FORMA DE PAGO' }
            ]}
            filas={sectionData.ventas || []}
            maxRowsShown={10}
            rowTemplate={row => (
              <Table.Row key={IdGen.newId()}>
                <Table.Cell>{row.ladoIsla || '--'}</Table.Cell>
                <Table.Cell>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
                <Table.Cell>{row.cantidad || '--'}</Table.Cell>
                <Table.Cell>{row.monto || '--'}</Table.Cell>
                <Table.Cell>{row.infoPago || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </>
      )}
    </>
  )
}

export default React.memo(VentasSection)
